showHidePassword = function () {
    var element = document.getElementById("password_id");
    if (element.type == "password") {
        element.type = "text";
    }
    else if (element.type == "text") {
        element.type = "password";
    }
}
var IsLoginFormValid = function () {
    var isValid = true;
    if (!ValidateUsername())
        isValid = false;
    if (!ValidatePasswordLogin())
        isValid = false;
    return isValid;
}
ValidateUsername = function () {
    return LoginRequiredFieldValidation('#username_id', '#uname-error');
}
ValidatePasswordLogin = function () {
    return LoginRequiredFieldValidation('#password_id', '#pass-error');
}
function validateLogin() {
    // setTimeout(function () {
    // var formValid = document.forms["login-form"].checkValidity();
    var username = $("#username_id").val(); var password = $("#password_id").val();
    $("#signin-errorblock").hide();
    if (IsLoginFormValid()) {

        if (!username || !password) {
            return false;
        }
        var signinParameters = {
            UserName: username,
            Password: password,
            RememberMe: $('#remember').is(":checked"),
        };
        $.ajax({
            method: $("#login-form").attr("method"),
            dataType: 'JSON',
            url: "/login/signin",
            beforeSend: function (request) {
                request.setRequestHeader("RequestVerificationToken", $("[name='__RequestVerificationToken']").val());
            },
            async: false,
            data: JSON.stringify(signinParameters),
            contentType: "application/json",
            success: onLoginSuccess,
            failure: onLoginFailure
        });
    }
    return false;
    //}, 2000);
}
var onLoginSuccess = function (data) {
    if (data.isSucceeded) {
        CheckAccounts();
    }
    else if (data.message.length > 0) {
        $(".signin-error").text(data.message);
        $(".signin-error").show();
        $("#signin-errorblock").show();
    }
}
var onLoginFailure = function (data) {
    $(".signin-error").text("Please try again.");
    $(".signin-error").show();
    $("#signin-errorblock").show();
}
ValidateResetUsername = function () {
    return LoginRequiredFieldValidation('#reset-username', '#reset-uname-error');
}
function validateResetForm() {
    // var formValid = document.forms["resetform"].checkValidity();
    $("#reset-errorblock").hide();
    if (ValidateResetUsername()) {
        var emailOrUsername = $("#reset-username").val();
        if (!emailOrUsername) {
            return false;
        }
        params = '{EmailOrUsername: "' + emailOrUsername + '"}';
        $.ajax({
            method: "GET",
            url: "/api/login/reset",
            async: false,
            data: { signinParameters: params },
            contentType: "application/json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('RequestVerificationToken', $("#resetform [name='__RequestVerificationToken']").val());
            },
            success: onResetSuccess,
            failure: onResetFailure
        });
    }
    return false;
}
var onResetSuccess = function (data, status) {
    if (data.isSucceeded) {
        $(".reset-screen").fadeOut();
        $(".success-screen").fadeIn();
    } else {
        $("#reset-errorblock").show();
        $(".reset-error-message").text(data.message);
    }
}
var onResetFailure = function (data) {
    $("#reset-errorblock").show();
    $(".reset-error-message").text("Please try again.");
}

ValidateAccountCode = function () {
    return LoginRequiredFieldValidation('#acc-code', '#forgot-code-error');
}
// Email Validation
ValidateCustomerEmail = function () {
    var email = $("#reset-email").val(); var email_regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email == "" || email == null || email == undefined) {
        $('#reset-email').addClass("field-error");
        $("#forgot-email-error").text('Please enter a valid email address');
        $("#forgot-email-error").show();
        return false;
    }
    else if (!email_regex.test(email)) {
        $('#reset-email').addClass("field-error");
        $("#forgot-email-error").text('Please enter a valid email address');
        $("#forgot-email-error").show();
        return false;
    }
    else {
        $('#reset-email').removeClass("field-error");
        $("#forgot-email-error").hide();
        return true;
    }
}
var IsForgotUsernameFormValid = function () {
    var isValid = true;
    if (!ValidateAccountCode())
        isValid = false;
    if (!ValidateCustomerEmail())
        isValid = false;
    return isValid;
}
function validateResetByAccountCode() {
    //var formValid = document.forms["resetByAccountCode"].checkValidity();
    $("#reset-errorblock").hide();
    if (IsForgotUsernameFormValid()) {
        var code = $("#acc-code").val(); var email = $("#reset-email").val();
        if (!email || !code) {
            return false;
        }
        var signinParameters = {
            Email: email,
            Code: code
        };
        $.ajax({
            method: "POST",
            dataType: 'JSON',
            url: "/api/login/resetbycode",
            async: false,
            data: JSON.stringify(signinParameters),
            contentType: "application/json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('RequestVerificationToken', $("#resetByAccountCode [name='__RequestVerificationToken']").val());
            },
            success: onResetSuccess,
            failure: onResetFailure
        });
    }
    return false;
}

var openPopup = function () {
    //$(".login-popup").show();
    $(".login").show();
    return false;
};

$(document).ready(function (event) {
    AutoFillUsername();
    var url = window.location; if (url.hash == '#forgot') { $(".login-dialog").hide(); $(".reset-screen").show(); }
    $(".login-btn").click(function (e) {
        e.preventDefault();
        ClearLoginPopup();
        AutoFillUsername();
        $(".user-controls .login-popup .dialog .close-dialog").show();
        $(".account-close").show();
        $(".login-dialog").show();
        $(".login-popup").fadeIn();
        $(".login").fadeIn();
    });
    $(".close-dialog").click(function (e) {
        e.preventDefault();
        $(".login-popup").fadeOut();
        $(".login").fadeOut();
        ClearLoginPopup();
    });
    $('.forgot').on("click", function (event) {
        ClearForgotPopup();
    });

    $('.back-link').on("click", function (event) {
        ClearLoginPopup();
    });

    // This script is in main.min.js but not loading so added here
    $(".account-selector-popup .accounts-dropdown ul").on('click', 'li', function () {
        $(".account-selector-popup .accounts-dropdown ul li").removeClass("active"),
            $(this).addClass("active"),
            $(".account-popup-error").hide()
    });

    $(".account-close").click(function () {
        var url = window.location;
        if (url.pathname == '/login') {
            $(".login-dialog").show();
        }
    });

    $('.info').click(function (event) {
        /*event.stopPropagation();*/ // Stop event propagation to prevent immediate dismissal
        $('.tooltip').toggleClass('active'); // Toggle class 'active'
    });
});

var ClearLoginPopup = function (e) {
    $('.login-popup input[type=text],.login-popup input[type=password] ').val('');
    $('#signin-errorblock .signin-error').text('');
    $('#signin-errorblock').hide();
    $('.error-message').hide();
    $('#remember').prop('checked', false);
    if (window.history.pushState) {
        window.history.pushState('', '/', location.pathname + location.search)
    } else {
        window.location.hash = '';
    }
}
var ClearForgotPopup = function (e) {
    $('.login-popup input[type=text],.login-popup input[type=email]').val('');
    $('#reset-errorblock .signin-error').text('');
    $('#reset-errorblock').hide();
    $('.error-message').hide();
}

function Logout() {

    fetch('/login/signout', { method: 'POST' })
        .then(response => response.json())
        .then(result => {
            if (result === true) {
                location.reload(); // redirect only after confirmed logout
            }
        }
        );
}


var CheckAccounts = function () {
    var params = {
        username: $("#username_id").val(),
        password: $("#password_id").val(),
        rememberme: $('#remember').is(":checked"),
    };
    GetAccounts(params);
}

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]").toLowerCase();
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search.toLowerCase());
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}
var ConfirmAccount = function () {
    var account = $(".account-selector-popup .accounts-dropdown ul li.active");
    if (account.length > 0) {
        $(".account-selector-popup #middys-overlay").show();
        $(".account-popup-error").hide();
        var params = {
            username: $("#username_id").val(),
            password: $("#password_id").val(),
            accountNo: account.find(".acc-no").attr("data-acct"),
            changeAccount: $(".acct-confirm").attr("data-type"),
            rememberme: $('#remember').is(":checked")
        };
        $.ajax({
            method: "POST",
            dataType: 'JSON',
            url: "/login/multiaccount",
            async: false,
            data: JSON.stringify(params),
            contentType: "application/json",
            beforeSend: function (xhr) {
                xhr.setRequestHeader('RequestVerificationToken', $("#login-form [name='__RequestVerificationToken']").val());
            },
            success: function (data) {
                $(".account-selector-popup #middys-overlay").hide();
                if (data.isValid) {
                    var url = window.location;
                    if (url.pathname == '/login') {
                        var returnUrl = getParameterByName('ReturnUrl');
                        if (returnUrl == '' || returnUrl == null || returnUrl == undefined)
                            window.location.href = '/home';
                        else
                            window.location.href = returnUrl;
                    }
                    else
                        window.location.href = window.location.href;
                }
                else
                    ShowErrorMessage_Account(data.errorMessage);
            },
            failure: function () {
                $(".account-selector-popup #middys-overlay").hide();
                ShowErrorMessage_Account("Something went wrong. Please try again.");
            }
        });
    }
    else
        ShowErrorMessage_Account("An account must be selected to proceed.");
}

var GetAccounts = function (params, changeAccount = false) {
    $("#signin-errorblock").hide();
    $.ajax({
        method: "POST",
        dataType: 'JSON',
        url: "/login/useraccounts",
        async: false,
        data: JSON.stringify(params),
        contentType: "application/json",
        beforeSend: function (xhr) {
            xhr.setRequestHeader('RequestVerificationToken', $("#login-form [name='__RequestVerificationToken']").val());
        },
        success: function (data) {
            $(".account-selector-popup #middys-overlay").hide();
            if (data.length == 1) {
                var url = window.location;
                if (url.pathname == '/login') {
                    var returnUrl = getParameterByName('ReturnUrl');
                    if (returnUrl == '' || returnUrl == null || returnUrl == undefined)
                        window.location.href = '/home';
                    else
                        window.location.href = returnUrl;
                }
                else
                    window.location.href = window.location.href;
            }
            else if (data.length > 1) {
                $(".accounts-data").html(''); $(".other-title").hide();
                $("#account-cancel-btn").show();
                $(".account-selector-popup").show();
                $(".account-selector-popup .current-acct").html('');
                if (changeAccount) {
                    BindCurrentAccountDetails();
                }
                else
                    $(".login-dialog").hide();
                html = '';
                $.each(data, function (i) {
                    if (!(changeAccount && $(".account-header .acc-num").text() == data[i].prontoAccountNo)) {
                        var accountName = data[i].name;
                        if (accountName.length > 36) {
                            accountName = accountName.substring(0, 36) + "...";
                        }
                        html += "<li class='sidebar-header flex-align-center'>";
                        html += "<img src='/images/profile-icon-pink.svg'>";
                        html += "<a class='account-header'>";
                        html += "<span>" + accountName + "</span>";
                        html += "<span class='acc-no' data-acct='" + data[i].prontoAccountNo + "'>" + data[i].prontoAccountNo + "</span>";
                        html += "</a>";
                        html += "</li>";
                    }
                });
                $(".accounts-data").append(html);
                $('.acct-confirm').attr('data-type', changeAccount);
            }
            else if (data == "1") {
                $(".signin-error").html("This account is not authorised. Please <a href='/contact-us'>contact us</a> and a member of our team will assist you.");
                $(".signin-error").show();
                $("#signin-errorblock").show();
            }
            else {
                $(".signin-error").text("Something went wrong. Please try again.");
                $(".signin-error").show();
                $("#signin-errorblock").show();
            }
        }
    });
}

var ChangeAccount = function (username) {
    var params = {
        username: username
    };
    $(".login-dialog").hide();
    $(".login-popup").show();
    $(".account-close").show();
    GetAccounts(params, true);
}
var BindCurrentAccountDetails = function () {
    var currenthtml = '';
    currenthtml += "<div class='current-account flex-center-space-between'>";
    currenthtml += "<div class='sidebar-header flex-align-center'>";
    currenthtml += "<img src='/images/profile-icon-pink.svg'>";
    currenthtml += "<label class='account-header'>";
    currenthtml += "<span>" + $(".account-header .acc-name").text() + "</span>";
    currenthtml += "<span>" + $(".account-header .acc-num").text() + "</span>";
    currenthtml += "</label>";
    currenthtml += "</div>";
    currenthtml += "<label>Current</label>";
    currenthtml += "</div>";
    $(".account-selector-popup .current-acct").append(currenthtml);
    $(".other-title").show();
    $("#account-cancel-btn").hide();
}
LoginRequiredFieldValidation = function (fieldClass, errorClass) {
    var fieldData = $(fieldClass).val();
    if (fieldData == "" || fieldData == null || fieldData == undefined) {
        $(fieldClass).addClass("field-error");
        $(errorClass).show();
        return false;
    }
    else {
        $(fieldClass).removeClass("field-error");
        $(errorClass).hide();
        return true;
    }
}
ShowErrorMessage_Account = function (errorMessage) {
    $(".account-popup-error .mes-text").text(errorMessage);
    $(".account-popup-error").show();
    $('.account-popup-error').delay(4000).fadeOut(400);
}
